/** Default hosted backend when env vars are unset (see apiDoc.md). */
export const HOSTED_API_URL = "https://kasai-backend-v1.vercel.app/api";

/** Browser-side form POST base URL. */
export const API_BASE_URL =
  (typeof process !== "undefined" && process.env.NEXT_PUBLIC_API_URL) ||
  HOSTED_API_URL;

/** Server-side proxy base URL. */
export const BACKEND_API_URL =
  (typeof process !== "undefined" &&
    (process.env.BACKEND_API_URL || process.env.FORMS_BACKEND_URL)) ||
  HOSTED_API_URL;
